<template>
  <div :class="['group relative flex flex-col', backgroundClasses]">
    <slot name="picture"></slot>
    
    <div :class="['flex', 'flex-col', 'gap-1', 'py-4', largePadding ? 'px-8' : 'px-4', 'prose']">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IntTile',
    
    props: {
      largePadding: { type: Boolean, default: false },
      fullHeight: { type: Boolean, default: false },
      centerVertically: { type: Boolean, default: false },
      background: {
        type: String,
        validator(value) {
          return ['', 'white', 'gray', 'black'].includes(value)
        }
      }  
    },

    computed: {
      backgroundClasses() {
        let classes = []
        
        if (this.background) {
          if (this.background === 'black') classes.push('bg-black/50')
          if (this.background === 'white') classes.push('bg-white')
          if (this.background === 'gray') classes.push('bg-gray-100')
        }
        
        if (this.fullHeight) classes.push('h-full')
        if (this.centerVertically) classes.push('justify-center')
        
        return classes
      }
    }
  }
</script>